/**
 * Formas crudas que devuelve el plugin nativo `HealthKitPlugin` (Swift), ya
 * serializadas a JSON (fechas en epoch millis). `healthKitAdapter.ts` es el
 * unico lugar que conoce estas formas; el resto de VitalAI solo ve
 * NormalizedDailyMetrics.
 *
 * Los valores numericos de `SLEEP_ANALYSIS_VALUE` corresponden a
 * `HKCategoryValueSleepAnalysis` (documentacion oficial de Apple).
 */
export const SLEEP_ANALYSIS_VALUE = {
  inBed: 0,
  asleepUnspecified: 1,
  awake: 2,
  asleepCore: 3,
  asleepDeep: 4,
  asleepREM: 5,
} as const;

export type HealthKitQuantityKey =
  | 'heartRate'
  | 'restingHeartRate'
  | 'hrv'
  | 'spo2'
  | 'respiratoryRate'
  | 'steps'
  | 'activeEnergyBurned'
  | 'exerciseTime'
  | 'bodyMass'
  | 'bodyTemperature';

export interface RawHealthKitQuantitySample {
  type: HealthKitQuantityKey;
  value: number;
  startDate: number;
  endDate: number;
  sourceName: string;
}

export interface RawHealthKitSleepSample {
  type: 'sleepAnalysis';
  /** Uno de los valores de SLEEP_ANALYSIS_VALUE. */
  value: number;
  startDate: number;
  endDate: number;
  sourceName: string;
}

export interface RawWorkoutSample {
  type: 'workout';
  /** rawValue de HKWorkoutActivityType. */
  workoutActivityType: number;
  /** segundos */
  duration: number;
  /** kcal */
  totalEnergyBurned: number;
  startDate: number;
  endDate: number;
  sourceName: string;
}

export type HealthKitSample = RawHealthKitQuantitySample | RawHealthKitSleepSample | RawWorkoutSample;
